import { present } from 'shared/presenters/presenter'
import { Enthusiasts } from 'shared/presenters/graphqlTypes'

export class EnthusiastPresenter extends present<Enthusiasts>() {}
